export const waitForElement = async (id: string, timeoutMs = 5000, step = 50) => {
    const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))
    const start = Date.now()
    let el: HTMLElement | null = document.getElementById(id)
    while (!el && Date.now() - start < timeoutMs) {
      await sleep(step)
      el = document.getElementById(id)
    }
    return el
  }